import { therapyRepositoryImplementation } from '@shared/infrastructure/http/repositories/therapy/therapyRepositoryImplementation';
import { Therapy } from './therapy.aggregate';

interface TherapyRepository {
  getTherapies: (
    countryCode: string,
    languageCode: string
  ) => Promise<Therapy[]>;
  toggleEnableTherapy: (
    therapyId: number,
    countryCode: string
  ) => Promise<void>;
}

export const therapyRepository: TherapyRepository = {
  getTherapies: (countryCode, languageCode) => {
    return therapyRepositoryImplementation.getTherapies(
      countryCode,
      languageCode
    );
  },
  toggleEnableTherapy: (therapyId, countryCode) => {
    return therapyRepositoryImplementation.toggleEnableTherapy(
      therapyId,
      countryCode
    );
  }
};
